import React, { useEffect, useRef, useState } from "react";

const AboutWrapper = () => {
  const statsRef = useRef(null);
  const [counts, setCounts] = useState({ clients: 0, projects: 0, engineers: 0 });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCount('clients', 320, 2000);
          animateCount('projects', 850, 2000);
          animateCount('engineers', 35, 1500);
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  const animateCount = (key, target, duration) => {
    const startTime = performance.now();
    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const current = Math.round(eased * target);
      setCounts(prev => ({ ...prev, [key]: current }));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  return (
    <section className="revamp-about">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6 revamp-reveal">
                    <div className="about-img">
                        <img src="assets/new-images/IMG_3111.jpg" className="img-fluid" alt="ATH founders sitting together"/>
                    </div>
                </div>

                <div className="col-lg-6 mt-5 mt-lg-0">
                    <div className="section-title" style={{paddingLeft: '20px'}}>
                        <span className="revamp-section-badge revamp-reveal" style={{marginBottom: '30px', display: 'inline-block'}}>ABOUT COMPANY</span>
                        <h2 className="revamp-section-title revamp-reveal">Who we are</h2>
                        <div className="revamp-reveal">
                            <p className="revamp-about-text" style={{lineHeight: '1.8'}}>We are a dynamic technology hub committed to empowering innovators, nurturing talent, and driving digital transformation. At our core, we bring together creativity, technical expertise, and entrepreneurial thinking to build solutions that matter.
<br />
We don&apos;t just deliver technology. We cultivate ideas, support growth, and create opportunities that shape the future of tech in Abia and beyond.
                            </p>
                        </div>

                        <div className="revamp-stats-grid revamp-reveal" ref={statsRef}>
                            <div className="revamp-stat-card">
                                <h3>{counts.clients}+</h3>
                                <p>Active Clients</p>
                            </div>
                            <div className="revamp-stat-card">
                                <h3>{counts.projects}+</h3>
                                <p>Projects Done</p>
                            </div>
                            <div className="revamp-stat-card">
                                <h3>{counts.engineers}+</h3>
                                <p>Engineers</p>
                            </div>
                        </div>

                        <a href="/about" className="revamp-btn revamp-btn--primary revamp-reveal" style={{marginTop: '10px'}}>Know us more <i className="fas fa-arrow-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default AboutWrapper;